
import React, { useEffect, useState } from 'react';
import { applyForCertification, fetchCertificationDetails, fetchCourseDetails, getCertificationCount, postcertificationDetails, uploadfiletos3 } from '../../service/certificationAPI';
import ApplyCertificationPopup from '../certificationPopup/ApplyCertification';
import { encryptStorage } from '../../constant';
import { CertificationDetails } from '../certificationPopup/CertificateDetailsPopup';
import { Breadcrumb } from 'antd';
import BreadCrumbs from '../BreadCrumbs/BreadCrumbs';
import { Toaster } from '../SoftSkills/Toast';
import DOMPurify from 'dompurify';
import { getS3 } from "../../utils/Download";


const EmployeeCertifications = ({ hideHeader = false }) => {
    const [certificates, setCertificates] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [numberOfRecords, setNumberOfRecords] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [searchTerm, setSearchTerm] = useState("");
    const [filterValue, setFilterValue] = useState({
        provider: "",
        createdFrom: "",
        createdTo: ""
    });
    const [errorMessage, setErrorMessage] = useState("");
    const [showSuccessToast, setShowSuccessToast] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [sortColumn, setSortColumn] = useState("req_id");
    const [sortOrder, setSortOrder] = useState(-1);
    const [showApplyPopup, setShowApplyPopup] = useState(false);
    const [applyFormData, setApplyFormData] = useState({
        certificateName: "",
        provider: "",
        materialsLink: ""
    });
    const [providers, setProviders] = useState([]);
    const [employeeName, setEmployeeName] = useState(encryptStorage.getItem('employeeName'))
    const [empDomain, setempDomain] = useState(encryptStorage.getItem('domain'))
    const [empId, setEmpId] = useState(encryptStorage.getItem('employeeId'))

    const [showDetails, setShowDetails] = useState(false);
    const [selectedCertificate, setSelectedCertificate] = useState(null);

    const [currentnumberofRecords, setCurrentnumberofRecords] = useState(0);
    const showLoadMore = certificates?.length >= 10;

    const groupId = encryptStorage.getItem('groupid');
    const domain = encryptStorage.getItem('domain');
    const [roundedCtc, setRoundedCtc] = useState(0);
    const [allowedCertifications, setAllowedCertifications] = useState(0);
    const [completedCertifications, setCompletedCertifications] = useState(0);
    const [costLimit, setCostLimit] = useState(0);
    const [s3Link, sets3Link] = useState("")

    useEffect(() => {
        fetchCertificationCount();
    }, [showApplyPopup]);

    useEffect(() => {
        fetchCertifications();
    }, [searchTerm, sortColumn, sortOrder, currentnumberofRecords]);



    let breadCrumbData = [
        { title: 'Dashboard', path: '/overview', isActive: true },
        { title: 'How Do I ?', path: '/overview', isActive: true },
        { title: 'Certifications', path: '/usercertification', isActive: false }
    ];

    //SQ- 1.23- 1.43 : fetchCertifications


    const fetchCertifications = async () => {
        setIsLoading(true);
        try {
            const params = {
                emp_id: empId,
                group_id: groupId,
                domain: domain,
                current_number_of_records: currentnumberofRecords,
                page_size: pageSize,
                search_term: searchTerm,
                sort_column: sortColumn,
                sort_order: sortOrder,
            };

            // Apply filters as individual query params (not nested)
            if (filterValue.provider) {
                params["filter.provider"] = filterValue.provider;
            }
            if (filterValue.createdFrom) {
                params["filter.created_date.from"] = filterValue.createdFrom;
            }
            if (filterValue.createdTo) {
                params["filter.created_date.to"] = filterValue.createdTo;
            }

            const response = await fetchCertificationDetails(params);
            if (response.status === "success") {
                setCertificates(response.data.certificates || []);
                setTotalRecords(response.data.meta?.total_count || 0);
                setNumberOfRecords(response.data.meta?.count || 0);
                setProviders(response.data.providers || []); // Add this line

            }
        } catch (error) {
            console.error("Error fetching certifications:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const fetchCertificationCount = async () => {
        try {
            const params = { emp_id: empId };
            const statsData = await getCertificationCount(params);
            setRoundedCtc(statsData.roundedCtc);
            setAllowedCertifications(statsData.allowedCertifications);
            setCompletedCertifications(statsData.completedCertifications);
            setCostLimit(statsData.costLimit);
            sets3Link(statsData.s3Link)
        } catch (error) {
            console.error("Error fetching certification count:", error);
        }
    };

    const checkFiltersActive = () => {
        return filterValue.provider || filterValue.createdFrom || filterValue.createdTo;
    };

    // seq 9.21 - 9.22
    // Function to handle button click and open signed URL
    const handleS3LinkClick = async (s3Link) => {
        try {
            // Call getS3url to get the signed URL
            const signedUrlResponse = await getS3(s3Link);

            // Adjust the property name based on your actual response structure
            const signedUrl = signedUrlResponse?.signedUrl || signedUrlResponse;

            if (signedUrl) {
                // Open the signed URL in a new tab
                window.open(signedUrl, '_blank');
            } else {
                console.error('No signed URL received in response');
            }
        } catch (error) {
            console.error('Error fetching signed S3 URL:', error);
        }
    };


    //SQ 5.0 - 5.7 : Handles the search
    const handleSearchChange = (event) => {
        setSearchTerm(DOMPurify.sanitize(event.target.value));
    };

    const handleCertificateClick = (certificate) => {
        setSelectedCertificate(certificate);
        setShowDetails(true);
    };

    // SQ-3.12 - 3.14 : Handle the apply click and certificate Submission
    const handleApplyClick = () => {
        setShowApplyPopup(true)
    };

    const handleSubmitApplication = async (applicationData) => {
        try {
            await applyForCertification(applicationData);
            await fetchCertifications()
            setShowApplyPopup(false);
        } catch (error) {
            setErrorMessage("Failed to submit application");
        }
    };
    // SQ- 9.1 - 9.19 Handle sorting
    const handleSortChange = (column) => {
        if (sortColumn === column) {
            setSortOrder(prev => -prev); // Toggle between 1 (↑) and -1 (↓)
        } else {
            setSortColumn(column);
            setSortOrder(1); // New column starts with ascending (↑)
        }
    };

    // SQ 3.5 - 3.18  Handle filter change

    const handleFilterChange = (event) => {
        const sanitizeValue = DOMPurify.sanitize(event.target.value);
        const { name } = event.target;
        setFilterValue(prev => ({ ...prev, [name]: sanitizeValue }));
    };
    const handleApplyFilters = () => {
        fetchCertifications();
    };

    const handleClearFilters = () => {
        // Create a completely clean params object
        const cleanParams = {
            emp_id: empId,
            group_id: groupId,
            domain: domain,
            current_number_of_records: 0, // Reset to first page
            page_size: pageSize,
            sort_column: sortColumn,
            sort_order: sortOrder
        };

        // Reset all local state
        setFilterValue({
            provider: "",
            createdFrom: "",
            createdTo: ""
        });
        setSearchTerm("");
        setCurrentnumberofRecords(0);

        // Make the API call with clean params immediately
        fetchCertificationDetails(cleanParams)
            .then(response => {
                if (response.status === "success") {
                    setCertificates(response.data.certificates || []);
                    setTotalRecords(response.data.meta?.total_count || 0);
                    setNumberOfRecords(response.data.meta?.count || 0);
                    setProviders(response.data.providers || []);
                }
            })
            .catch(error => {
                console.error("Error fetching certifications:", error);
                setErrorMessage("Failed to fetch certifications");
            });
    };
    const handleShowMore = () => {
        setCurrentnumberofRecords(prev => prev + 1);
    };
    //2.31-2.40 : Handles the status for display
    const getStatusDisplay = (certificate) => {
        // Safely get field values
        const getFieldValue = (field, defaultValue = '') => {
            if (!field || !field.Valid) return defaultValue;
            return field.String !== undefined ? field.String :
                field.Bool !== undefined ? field.Bool :
                    defaultValue;
        };

        // Get all relevant values
        const initialApproval = getFieldValue(certificate.initial_ph_approval, "pending").toLowerCase();
        const isPaymentCompleted = getFieldValue(certificate.is_payment_completed, false);
        const financialApproval = getFieldValue(certificate.financial_approval, "").toLowerCase();
        const certificationCompletion = getFieldValue(certificate.certification_completion_approval, "pending").toLowerCase();
        const isCourseCompleted = getFieldValue(certificate.is_course_completion, false);
        const passReattemptStatus = getFieldValue(certificate.pass_reattempt_status, "").toLowerCase();

        // Determine statuses for each step
        let initialStatus = "pending";
        let paymentStatus = "pending";
        let completionStatus = "pending";
        let statusText = "Pending";
        let statusClass = "pending";

        // Initial Approval Status
        if (initialApproval === "rejected") {
            initialStatus = "rejected";
            statusText = "Rejected";
            statusClass = "rejected";
        }
        else if (initialApproval === "approved") {
            initialStatus = "approved";

            // Payment Status
            if (isPaymentCompleted) {
                paymentStatus = "approved";
                if (certificationCompletion === "approved" && passReattemptStatus === "failed") {
                    statusText = "Certification Failed"; // Set status text for failed certification
                    completionStatus = "rejected"; // Set class to rejected
                } else {
                    // Certification Completion Status
                    if (certificationCompletion === "approved") {
                        completionStatus = "approved";
                        statusText = "Course Completed";
                        statusClass = "approved";
                    }
                    else if (certificationCompletion === "inprogress") {
                        completionStatus = "inprogress";
                        statusText = "Certification In Progress";
                        statusClass = "inprogress";
                    }
                    else if (certificationCompletion === "rejected") {
                        completionStatus = "rejected";
                        statusText = "Certification Rejected";
                        statusClass = "rejected";
                    }
                    else {
                        statusText = "Payment Completed";
                        statusClass = "approved";
                    }
                }
            }
            else if (financialApproval === "inprogress") {
                paymentStatus = "inprogress";
                statusText = "Payment In Progress";
                statusClass = "inprogress";
            }
            else {
                statusText = "Approved";
                statusClass = "approved";
            }
        }
        else if (initialApproval === "inprogress") {
            initialStatus = "inprogress";
            statusText = "Initial Approval In Progress";
            statusClass = "inprogress";
        }

        return {
            statusText,
            statusClass,
            initialStatus,
            paymentStatus,
            completionStatus
        };
    };
    const uploadCertificateToS3 = async (fileData) => {
        try {
            const file = fileData.certificate_file;
            const arrayBuffer = await file.arrayBuffer();
            const byteArray = new Uint8Array(arrayBuffer);
            const bytes = Array.from(byteArray);
            // seq 3.22 - payload along with reupload status
            const requestData = {
                request_id: fileData.request_id,
                emp_id: fileData.emp_id,
                certificate_file: bytes,
                certificate_name: fileData.certificate_name,
                provider: fileData.provider,
                specialization: fileData.specialization,
                year_of_completion: fileData.year_of_completion,
                original_filename: fileData.original_filename,
                is_reupload: fileData.is_reupload

            };
            const response = await uploadfiletos3(requestData);

            if (response.status === "success") {
                setShowDetails(false)
                await fetchCertifications()
                return {
                    url: response.data.certificate_url,
                    success: true
                };

            } else {
                throw new Error(response.message || "Failed to upload certificate");
            }
        } catch (error) {
            console.error('Upload error:', error);
            throw error;
        } finally {
            setIsLoading(false);
        }
    };

    //SQ_2.17 - 2.30 : handles the approval status
    const postCertificationApproval = async (approvalData) => {
        try {
            setIsLoading(true);

            const data = await postcertificationDetails(approvalData);
            return data;
        } catch (error) {
            console.error('Approval error:', error);
            setErrorMessage("Failed to submit approval");
            throw error;
        } finally {
            setIsLoading(false);
        }
    };

    const formatDate = (dateString) => {
        if (!dateString) return '';
        const [year, month, day] = dateString.split('-').map(Number);
        const date = new Date(Date.UTC(year, month - 1, day)); // Treat as UTC
        const options = { day: '2-digit', month: '2-digit', year: 'numeric', timeZone: 'UTC' };
        return date.toLocaleDateString('en-US', options).replace(/\//g, '-');
    };


    const getFieldValue = (field, defaultValue = '') => {
        if (!field || !field.Valid) return defaultValue;
        return field.String !== undefined ? field.String :
            field.Bool !== undefined ? field.Bool :
                defaultValue;
    };

    const sanitizedMaterialsLink = (link) => {
        return DOMPurify.sanitize(link);
    };

    return (
        <div className="body-bg">
            <div className="container-fluid mt-6">
                <Toaster />
                <div className="row justify-content-center">
                    <div className="col-md-12 d-flex align-items-center">
                        <BreadCrumbs data={breadCrumbData} />
                    </div>
                    <div className="col-md-12 d-flex align-items-center">
                        {!hideHeader && (

                            <div className="col-md-12 d-flex justify-content-between align-items-center mb-4">

                                <h4 className='font-20'>Certifications</h4>
                                <div className="d-flex align-items-center gap-3">

                                    <div className="input-group flex-nowrap search-group ">
                                        <input
                                            type="search"
                                            className="form-control search-align"
                                            placeholder="Search"
                                            value={searchTerm}
                                            onChange={handleSearchChange}
                                        />
                                        <button
                                            className="input-group-text btn btn-search-custom" id="addon-wrapping"
                                        // onClick={() => fetchCertifications()}
                                        >
                                            <img src="/Images/search-icon.svg" alt="search-icon" />
                                        </button>
                                    </div>

                                    {/* Filter Section */}
                                    <div className="dropdown">
                                        <button
                                            className="advanced-filter-button medium-text d-flex align-items-center"
                                            type="button"
                                            id="dropdownMenuButton1"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                        >
                                            <img src="/Images/filter-icon.svg" alt="Filter-icon" className="me-2" />Filter
                                        </button>

                                        <div className="dropdown-menu px-3 advanced-filter-panel shadow session-filter mt-5" aria-labelledby="dropdownMenuButton1">
                                            <div className="row">
                                                <div class="col-md-12 py-2 border-0 mb-1">
                                                    <span className="font-16 semibold-text advanced-filter-title">Advanced Filter</span>
                                                    <button
                                                        type="button"
                                                        className="btn-close float-end close-filter"
                                                        data-bs-dismiss="advanced-filter"
                                                        aria-label="Close"
                                                    ></button>
                                                </div>

                                                <div className="col-md-12">
                                                    {/* Provider Dropdown */}
                                                    <div className="row mb-3">
                                                        <div className="col-md-12 mb-3">
                                                            <label className="form-label hive-form-label" htmlFor="provider">Provider</label>
                                                            <select
                                                                className="form-select hive-form-select"
                                                                id="provider"
                                                                name="provider"
                                                                value={filterValue.provider}
                                                                onChange={handleFilterChange}
                                                            >
                                                                <option value="">Select</option>
                                                                {providers.map(provider => (
                                                                    <option key={provider} value={provider}>
                                                                        {provider}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>

                                                    {/* Created On Date Range */}
                                                    <div className="col-md-12 pb-2 border-0">
                                                        <span className="font-14 semibold-text filter-title">Created On</span>
                                                    </div>

                                                    <div className="row mb-3">
                                                        <div className="col-md-6 mb-3">
                                                            <label className="form-label hive-form-label" htmlFor="createdFrom">From</label>
                                                            <input
                                                                type="date"
                                                                name="createdFrom"
                                                                className="form-control hive-form-control"
                                                                id="createdFrom"
                                                                value={filterValue.createdFrom}
                                                                onChange={handleFilterChange}
                                                            />
                                                        </div>

                                                        <div className="col-md-6 mb-3">
                                                            <label className="form-label hive-form-label" htmlFor="createdTo">To</label>
                                                            <input
                                                                type="date"
                                                                name="createdTo"
                                                                className="form-control hive-form-control"
                                                                id="createdTo"
                                                                value={filterValue.createdTo}
                                                                onChange={handleFilterChange}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Action Buttons */}
                                                <div className="col-md-12 my-3 d-flex justify-content-end">
                                                    <button
                                                        className="btn hive-btn-secondary me-3"
                                                        onClick={handleClearFilters}
                                                    >
                                                        Clear
                                                    </button>
                                                    <button
                                                        className="btn hive-btn-primary"
                                                        disabled={!checkFiltersActive()}
                                                        onClick={handleApplyFilters}
                                                    >
                                                        Apply
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <button
                                        className="btn hive-btn-primary"
                                        onClick={handleApplyClick}
                                    >
                                        Apply Certification
                                    </button>
                                    <button class="btn hive-btn-outline more-indicator-1 float-left cursor-pointer ms-2"
                                        onClick={() => handleS3LinkClick(s3Link)}>
                                        <img src="/Images/manual.svg" class="me-2" alt="import-icon" />
                                    </button>
                                    <div class="dropdown-items-1 border border-light mt-2 bg-white rounded-3 p-2 shadow">
                                        <div class="d-flex flex-wrap gap-2">
                                            <span class="practices-badge px-2 py-1 rounded-2">Click here to download the user manual</span>
                                        </div></div>
                                </div>
                            </div>

                        )}
                    </div>
                </div>

                {/* Certifications Table */}
                <div className="row mt-3">
                    <table className="table bg-white hive-grid mb-3 table-borderless">
                        <thead className="hive-table-head">
                            <tr>
                                <th
                                    onClick={() => handleSortChange("req_id")}
                                    className={`bold-text font-12 ${sortColumn === "req_id" ? (sortOrder === 1 ? "asc" : "desc") : ""
                                        }`}
                                >
                                    Request ID
                                    <span className="ps-2">
                                        <img
                                            src={sortColumn === "req_id"
                                                ? sortOrder === 1
                                                    ? "/Images/sort-icon.svg"    // ↑ when ascending
                                                    : "/Images/Sort-up.svg"  // ↓ when descending
                                                : "/Images/sort-icon.svg"}
                                            alt="Sorticon"
                                            className={`hive-table-sort ${sortColumn === "req_id" ? "active-sort" : ""
                                                }`}
                                        />
                                    </span>
                                </th>
                                <th
                                    onClick={() => handleSortChange("certificate_name")}
                                    className={`bold-text font-12 ${sortColumn === "certificate_name" ? (sortOrder === 1 ? "asc" : "desc") : ""
                                        }`}
                                >
                                    Certification Name
                                    <span className="ps-2">
                                        <img
                                            src={sortColumn === "certificate_name"
                                                ? sortOrder === 1
                                                    ? "/Images/sort-icon.svg"    // ↑ when ascending
                                                    : "/Images/Sort-up.svg"  // ↓ when descending
                                                : "/Images/sort-icon.svg"}
                                            alt="Sorticon"
                                            className={`hive-table-sort ${sortColumn === "certificate_name" ? "active-sort" : ""
                                                }`}
                                        />
                                    </span>
                                </th>
                                <th
                                    onClick={() => handleSortChange("provider")}
                                    className={`bold-text font-12 ${sortColumn === "provider" ? (sortOrder === 1 ? "asc" : "desc") : ""
                                        }`}
                                >
                                    Provider
                                    <span className="ps-2">
                                        <img
                                            src={sortColumn === "provider"
                                                ? sortOrder === 1
                                                    ? "/Images/sort-icon.svg"    // ↑ when ascending
                                                    : "/Images/Sort-up.svg"  // ↓ when descending
                                                : "/Images/sort-icon.svg"}
                                            alt="Sorticon"
                                            className={`hive-table-sort ${sortColumn === "provider" ? "active-sort" : ""
                                                }`}
                                        />
                                    </span>
                                </th>
                                <th
                                    onClick={() => handleSortChange("created_date")}
                                    className={`bold-text font-12 ${sortColumn === "created_date" ? (sortOrder === 1 ? "asc" : "desc") : ""
                                        }`}
                                > Created On
                                    <span className="ps-2">
                                        <img
                                            src={sortColumn === "craeted_on"
                                                ? sortOrder === 1
                                                    ? "/Images/sort-icon.svg"
                                                    : "/Images/Sort-up.svg"
                                                : "/Images/sort-icon.svg"}
                                            alt="Sorticon"
                                            className={`hive-table-sort ${sortColumn === "created_date" ? "active-sort" : ""
                                                }`}
                                        />
                                    </span>
                                </th>
                                <th
                                    onClick={() => handleSortChange("duration")}
                                    className={`bold-text font-12 ${sortColumn === "duration" ? (sortOrder === 1 ? "asc" : "desc") : ""
                                        }`}
                                >
                                    Completion Duration
                                    <span className="ps-2">
                                        <img
                                            src={sortColumn === "duration"
                                                ? sortOrder === 1
                                                    ? "/Images/sort-icon.svg"    // ↑ when ascending
                                                    : "/Images/Sort-up.svg"  // ↓ when descending
                                                : "/Images/sort-icon.svg"}
                                            alt="Sorticon"
                                            className={`hive-table-sort ${sortColumn === "completion_duration" ? "active-sort" : ""
                                                }`}
                                        />
                                    </span>
                                </th>
                                <th className="bold-text font-12">Materials Path Link</th>
                                <th className="bold-text font-12" >
                                    Status
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {certificates.map(cert => {
                                const { statusText, initialStatus, paymentStatus, completionStatus, statusClass } = getStatusDisplay(cert);
                                const isPending = getFieldValue(cert.initial_ph_approval, "pending").toLowerCase() === "pending";
                                return (
                                    <tr key={cert.req_id} className="hive-table-data regular-text">
                                        <td>
                                            {getFieldValue(cert.initial_ph_approval, "pending").toLowerCase() === "pending" ||
                                                (getFieldValue(cert.is_course_completion, false) &&
                                                    !getFieldValue(cert.certification_completion_approval)) ? (
                                                <span className="new-item-indicator rounded-circle"></span>
                                            ) : null}
                                            {getFieldValue(cert.is_payment_completed, "").toLowerCase() === "completed" ? (
                                                <span
                                                    className="text-primary cursor-pointer hover-underline"
                                                    onClick={() => handleCertificateClick(cert)}
                                                    style={{
                                                        color: '#0d6efd',
                                                        textDecoration: 'underline',
                                                        cursor: 'pointer'
                                                    }}
                                                >
                                                    {cert.req_id}
                                                </span>
                                            ) : (
                                                // Non-clickable version when payment is not completed
                                                <span className="text-secondary">
                                                    {cert.req_id}
                                                </span>
                                            )}
                                        </td>
                                        <td>{cert.certificate_name}
                                            {cert.client_dependency.Bool && (
                                                <span className="client-badge ms-2">Client</span>
                                            )}
                                        </td>
                                        <td>{cert.provider}</td>
                                        <td>{formatDate(cert.created_date)}</td>
                                        <td>
                                            {cert.duration.String !== "0" ? cert.duration.String
                                                : '-'}
                                        </td>
                                        <td style={{
                                            maxWidth: "200px",
                                            wordBreak: "break-all",
                                            whiteSpace: "normal",
                                        }}>
                                            <a
                                                href={sanitizedMaterialsLink(cert.materials.String)} // Sanitize before using
                                                target="_blank"
                                                rel='noopener noreferrer'
                                                className='text-decoration-none table-name-style'
                                                title={sanitizedMaterialsLink(cert.materials.String)} // Sanitize before using
                                                style={{
                                                    display: "inline-block",
                                                    whiteSpace: "nowrap",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    maxWidth: "100%",
                                                    verticalAlign: "middle"
                                                }}
                                            >
                                                {sanitizedMaterialsLink(cert.materials.String)
                                                    .replace(/^https?:\/\/(www\.)?/, '') // Remove http(s):// and optional www.
                                                    .substring(0, 30)} {/* Show first 30 characters */}
                                                {sanitizedMaterialsLink(cert.materials.String).length > 30 && '...'} {/* Add ellipsis if truncated */}
                                            </a>


                                        </td>
                                        <td>
                                            <div className="progress-indication-bar d-flex flex-column justify-content-center align-items-start">
                                                <span className={`font-11 mb-1 ${statusClass}`}>
                                                    {statusText}
                                                </span>
                                                <div className="d-flex align-items-center justify-content-center gap-1">
                                                    {/* Initial Approval */}
                                                    <span className={`progress-step ${initialStatus}`}></span>
                                                    <span className="progress-line"></span>

                                                    {/* Payment Completion */}
                                                    <span className={`progress-step ${paymentStatus}`}></span>
                                                    <span className="progress-line"></span>

                                                    {/* Certification Completion */}
                                                    <span className={`progress-step ${completionStatus}`}></span>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>

                    {/* Pagination */}
                    <p className="font-12 pagination">
                        Showing<span className="bold-text mx-1">{numberOfRecords}</span> of
                        <span className="bold-text mx-1">{totalRecords}</span> Records
                    </p>
                    {showLoadMore && (
                        <div className="text-center">
                            <button className="btn show-more-btn" onClick={handleShowMore}>Show More</button>
                        </div>
                    )}
                </div>

                {/* Toast Notifications */}
                {/* {showErrorToast && (
                <div className="toast show position-fixed bottom-0 end-0 m-3" role="alert" aria-live="assertive" aria-atomic="true">
                    <div className="toast-header bg-danger text-white">
                        <strong className="me-auto">Error</strong>
                        <button
                            type="button"
                            className="btn-close btn-close-white"
                            onClick={() => setShowErrorToast(false)}
                        ></button>
                    </div>
                    <div className="toast-body">
                        {errorMessage}
                    </div>
                </div>
            )}

            {showSuccessToast && (
                <div className="toast show position-fixed bottom-0 end-0 m-3" role="alert" aria-live="assertive" aria-atomic="true">
                    <div className="toast-header bg-success text-white">
                        <strong className="me-auto">Success</strong>
                        <button
                            type="button"
                            className="btn-close btn-close-white"
                            onClick={() => setShowSuccessToast(false)}
                        ></button>
                    </div>
                    <div className="toast-body">
                        {successMessage}
                    </div>
                </div>
            )} */}
                {
                    showApplyPopup && (
                        <ApplyCertificationPopup
                            show={showApplyPopup}
                            onClose={() => setShowApplyPopup(false)}
                            onSubmit={handleSubmitApplication}
                            employeeId={empId}
                            employeeName={employeeName}
                            domain={empDomain}
                            courses
                            completedCertifications={completedCertifications}
                            allowedCertifications={allowedCertifications}
                            appliedCertificates={certificates?.filter(cert => cert?.initial_ph_approval?.String !== "Rejected")?.map(cert => cert.certificate_id)}
                        />
                    )
                }
                {
                    showDetails && selectedCertificate && (
                        <CertificationDetails
                            showDetails={showDetails}
                            setShowDetails={setShowDetails}
                            onClose={() => {
                                setShowDetails(false);
                                fetchCertifications();
                            }}
                            certificateDetails={selectedCertificate}
                            onUploadCertificate={uploadCertificateToS3}
                            onPostApproval={postCertificationApproval}
                        />
                    )
                }

            </div >

        </div >

    );
};

export default EmployeeCertifications;
